export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '05c78ec', dateTime: 1785855148859 };